import { render } from "./questionsButtons.vue?vue&type=template&id=4cc17897"
import script from "./questionsButtons.vue?vue&type=script&lang=js"
export * from "./questionsButtons.vue?vue&type=script&lang=js"

import "./questionsButtons.vue?vue&type=style&index=0&id=4cc17897&lang=scss"

import exportComponent from "/Users/jeromebart/sites/cdm-quiz/cite-des-metiers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__